export namespace BonusStatusId {
  export const Coupon = 1n;
  export const Spin = 2n;
  export const Ticket = 3n;
  export const Activated = 4n;
  export const Issued = 5n;
  export const Supplied = 6n;
  export const Expired = 7n;
  export const Invalidated = 8n;
  export const Cancelled = 9n;
  export const Claimed = 10n;
  export const Pending = 11n;
}

export type BonusStatusIdType =
  (typeof BonusStatusId)[keyof typeof BonusStatusId];
